export interface TableHeadRowProps {
  className?: string;
}

export function TableHeadRow({ className, children }: React.PropsWithChildren<TableHeadRowProps>) {
  return <tr className={className}>{children}</tr>;
}

export default TableHeadRow;
